module.exports = __webpack_public_path__ + "img/djibouti.9f2ee85.webp";